<template>
  <div class="opreate-strategy-detail">
    <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">运营策略管理</el-breadcrumb-item>
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="model-title">基本信息</div>
    <el-card class="box-card">
      <el-form label-width="100px" class="orderForm" size="small" label-suffix=":">
        <el-form-item label="决策树名称">
          <label>{{ strategyInfo.name }}</label>
        </el-form-item>
        <el-form-item label="备注">
          <label>{{ strategyInfo.remark }}</label>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="model-title">决策树</div>
    <el-card class="box-card">
      <el-button type="primary" size="small" @click="onAddRuleClick">新增</el-button>
      <el-tree :data="strategyInfo.rules" node-key="id" default-expand-all :draggable="true">
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span style="margin-left: 50px">
            <el-button type="text" size="mini" @click="() => append(node, data)">
              添加下级
            </el-button>
            <el-button type="text" size="mini" @click="() => edit(node, data)">
              编辑节点
            </el-button>
            <el-button type="text" size="mini" @click="() => remove(node, data)">
              删除节点
            </el-button>
          </span>
        </div>
      </el-tree>
    </el-card>
    <div class="opreate-box">
      <el-button @click="cancelBtnClick">取 消</el-button>
      <el-button type="primary" @click="confirmBtnClick">确 定</el-button>
    </div>

    <el-dialog title="新增规则节点" :visible.sync="ruleDialogVisible" :close-on-click-modal="false" width="1000px">
      <div class="form-line">
        <span class="form-label">节点类型</span>
        <el-radio v-model="ruleInfo.nodeType" label="1">条件节点</el-radio>
        <el-radio v-model="ruleInfo.nodeType" label="2">决策节点</el-radio>
        <el-radio v-model="ruleInfo.nodeType" label="3">任务节点</el-radio>
        <el-radio v-model="ruleInfo.nodeType" label="4">阶段运营节点</el-radio>
      </div>
      <div class="rule-box" v-show="ruleInfo.nodeType == 1">
        <h2>匹配规则</h2>
        <div class="form-line">
          <span class="form-label">数据类型</span>
          <el-select class="form-select" placeholder="请选择" v-model="ruleInfo.dataType">
            <el-option label="请选择" :value="-1"></el-option>
            <el-option v-for="item in businessTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <span class="form-label">规则1</span>
          <el-select class="form-select" placeholder="请选择" v-model="ruleInfo.operator1" style="width: 100px;">
            <el-option label="请选择" value=""></el-option>
            <el-option label=">" value=">"></el-option>
            <el-option label=">=" value=">="></el-option>
            <el-option label="=" value="="></el-option>
            <!-- <el-option label="<" value="<"></el-option>
            <el-option label="<=" value="<="></el-option> -->
            <el-option label="!=" value="!="></el-option>
          </el-select>
          <el-input class="form-input" placeholder="请输入" v-model="ruleInfo.value1" clearable style="width: 150px;">
          </el-input>
        </div>
        <div class="form-line">
          <span class="form-label">规则2</span>
          <el-select class="form-select" placeholder="请选择" v-model="ruleInfo.operator2" style="width: 100px;">
            <el-option label="请选择" value=""></el-option>
            <!-- <el-option label=">" value=">"></el-option>
            <el-option label=">=" value=">="></el-option> -->
            <el-option label="=" value="="></el-option>
            <el-option label="<" value="<"></el-option>
            <el-option label="<=" value="<="></el-option>
            <el-option label="!=" value="!="></el-option>
          </el-select>
          <el-input class="form-input" placeholder="请输入" v-model="ruleInfo.value2" clearable style="width: 150px;">
          </el-input>
        </div>
      </div>
      <div class="opreate-box" v-show="ruleInfo.nodeType == 2">
        <h2>决策动作</h2>
        <div class="form-line">
          <span class="form-label">决策</span>
          <el-select class="form-select" placeholder="请选择" v-model="ruleInfo.adjustOperator" style="width: 120px;margin-right:20px">
            <el-option v-for="opreate in opreateList" :key="opreate.type" :label="opreate.label" :value="opreate.type"></el-option>
          </el-select>
          <el-input v-if="[1,2,5].includes(ruleInfo.adjustOperator)" class="form-input" placeholder="请输入" v-model="ruleInfo.adjustValue" clearable style="width: 200px;">
          </el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ruleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  requestModules
} from '@r'
export default {
  data() {
    return {
      ruleDialogVisible: false,
      dataList: [],
      strategyInfo: {
        name: "",
        remark: "",
        rules: []
      },
      data: [
        {
          id: 1,
          label: '一级 1',
          children: [{
            id: 4,
            label: '二级 1-1',
            children: [{
              id: 9,
              label: '三级 1-1-1'
            }, {
              id: 10,
              label: '三级 1-1-2'
            }]
          }]
        },
        {
          id: 2,
          label: '一级 2',
          children: [{
            id: 5,
            label: '二级 2-1'
          }, {
            id: 6,
            label: '二级 2-2'
          }]
        },
        {
          id: 3,
          label: '一级 3',
          children: [{
            id: 7,
            label: '二级 3-1'
          }, {
            id: 8,
            label: '二级 3-2'
          }]
        }],
      ruleInfo: {
        nodeType: "1",
        label: "",
        dataType: -1,
        typeLabel: "",
        operator1: ">",
        value1: "",
        operator2: "",
        value2: "",
        adjustOperator: -1,
        adjustValue: 0
      },
      tempNodeInfo: {},
      tempNode: {},
      tempOpreate: "",
      businessTypeList: [
        { label: "昨日展现数", value: 101 },
        { label: "昨日点击数", value: 102 },
        { label: "昨日点击率", value: 103 },
        { label: "昨日订单数量", value: 104 },
        { label: "昨日SKU订单", value: 105 },
        { label: "昨日其他SKU订单", value: 106 },
        { label: "昨日成交率", value: 107 },
        { label: "昨日ROAS", value: 108 },
        { label: "昨日ROIM", value: 109 },
        { label: "昨日广告支出", value: 110 },
        { label: "昨日销售额", value: 111 },
        { label: "7日展现数", value: 201 },
        { label: "7日点击数", value: 202 },
        { label: "7日点击率", value: 203 },
        { label: "7日订单数量", value: 204 },
        { label: "7日SKU订单", value: 205 },
        { label: "7日其他SKU订单", value: 206 },
        { label: "7日成交率", value: 207 },
        { label: "7日ROAS", value: 208 },
        { label: "7日ROIM", value: 209 },
        { label: "7日广告支出", value: 210 },
        { label: "7日销售额", value: 211 },
        { label: "30日展现数", value: 301 },
        { label: "30日点击数", value: 302 },
        { label: "30日点击率", value: 303 },
        { label: "30日订单数", value: 304 },
        { label: "30日SKU订单", value: 305 },
        { label: "30日其他SKU订单", value: 306 },
        { label: "30日成交率", value: 307 },
        { label: "30日ROAS", value: 308 },
        { label: "30日ROIM", value: 309 },
        { label: "30日广告支出", value: 310 },
        { label: "30日销售额", value: 311 },
        { label: "90日展现数", value: 401 },
        { label: "90日点击数", value: 402 },
        { label: "90日点击率", value: 403 },
        { label: "90日订单数", value: 404 },
        { label: "90日SKU订单", value: 405 },
        { label: "90日其他SKU订单", value: 406 },
        { label: "90日成交率", value: 407 },
        { label: "90日ROAS", value: 408 },
        { label: "90日ROIM", value: 409 },
        { label: "90日广告支出", value: 410 },
        { label: "90日销售额", value: 411 },

        { label: "运营周期", value: 501 },
        { label: "广告预算", value: 502 },
        { label: "访客数", value: 503 },
        { label: "订单数", value: 504 },
        { label: "点击率", value: 505 },
        { label: "转化率", value: 506 },
        { label: "评论数", value: 507 },
        { label: "优惠券折扣率", value: 508 },
        { label: "Vine计划", value: 509 },
        { label: "自然访客数", value: 510 },
        { label: "广告访客数", value: 511 },
        { label: "ROAS", value: 512 },
      ],
      opreateList: [
        { label: "提高竞价", type: 1 },
        { label: "降低竞价", type: 2 },
        { label: "启用", type: 3 },
        { label: "停用", type: 4 },
        { label: "广告预算", type: 5 },
        { label: "任务说明", type: 6 },
        { label: "无操作", type: -1 },
      ]
    }
  },
  mounted() {
    this.getStrategyDetail();
    this.initRuleInfo();
  },
  methods: {
    goBack() {
      this.$route.go(-1);
    },
    cancelBtnClick() {
      this.goBack();
    },
    confirmBtnClick() {
      let params = {
        _id: this.strategyInfo._id,
        name: this.strategyInfo.name,
        remark: this.strategyInfo.remark,
        rules: JSON.stringify(this.strategyInfo.rules)
      }
      requestModules.addOrUpdateStrategy(params).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '编辑失败'
          });
          return;
        }
        this.$message({
          type: 'success',
          message: '操作成功!'
        });
        this.goBack();
      }).catch((err) => {
        console.log(err);
      });
    },
    append(node, data) {
      this.tempOpreate = "append";
      this.tempNodeInfo = data;

      this.tempNode = this;
      // this.tempNodeInfo = data;
      this.ruleDialogVisible = true;

      this.initRuleInfo();
    },
    edit(node, data) {
      this.tempOpreate = "edit";
      this.tempNodeInfo = data;
      this.ruleDialogVisible = true;

      this.ruleInfo = data;
    },
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
    },
    getStrategyDetail() {
      console.log(this.$route.params.id)
      requestModules.fetchStrategy({ id: this.$route.params.id }).then(res => {
        this.data = JSON.parse(res.mdata.rules);
        this.strategyInfo = res.mdata;
        this.strategyInfo.rules = JSON.parse(this.strategyInfo.rules);
      })
    },
    deleteStrategy(data) {
      requestModules.deleteStrategy({ id: data.id }).then(res => {
        this.data = JSON.parse(res.data.rules);
      })
    },
    onAddRuleClick() {
      this.tempOpreate = "add";
      this.initRuleInfo();
      this.ruleDialogVisible = true;
    },
    initRuleInfo() {
      this.ruleInfo = {
        nodeType: "1",
        label: "",
        dataType: -1,
        typeLabel: "",
        operator1: ">",
        value1: "",
        operator2: "",
        value2: "",
        adjustOperator: -1,
        adjustValue: 0
      }
    },
    handleConfirmBtn() {
      this.ruleDialogVisible = false;
      let businessInfo = this.businessTypeList.find(business => business.value == this.ruleInfo.dataType)
      this.ruleInfo.typeLabel = businessInfo ? businessInfo.label : "未指定业务类型";
      let opreateInfo = this.opreateList.find(opreate => opreate.type == this.ruleInfo.adjustOperator)
      this.ruleInfo.adjustOperatorLabel = opreateInfo ? opreateInfo.label : "未指定决策类型";

      debugger

      this.ruleInfo.label = this.ruleInfo.nodeType == 1 ? this.getRuleNodeLabel() : this.getOpreateNodeLabel();
      this.ruleInfo.topic = this.ruleInfo.label;
      this.ruleInfo.expanded = true;
      this.ruleInfo.direction = "right";

      requestModules.addOrUpdateRuleNode(this.ruleInfo).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '编辑失败'
          });
          return;
        }
        if (this.tempOpreate == "add") {
          this.ruleInfo.id = res.mdata.id;
          this.strategyInfo.rules.push(this.ruleInfo);
        } else if (this.tempOpreate == "append") {
          this.ruleInfo.id = res.mdata.id;
          if (!this.tempNodeInfo.children) {
            this.$set(this.tempNodeInfo, 'children', [])
          }
          this.tempNodeInfo.children.push(this.ruleInfo)
        } else if (this.tempOpreate == "edit") {
          // this.tempNodeInfo.children.push(this.ruleInfo)
        }


        // if (!this.tempNodeInfo.children) {
        //   this.ruleInfo.id = res.mdata.id;
        //   this.$set(this.tempNodeInfo, 'children', [])
        //   this.tempNodeInfo.children.push(this.ruleInfo)
        // } else {
        //   if (!this.ruleInfo.id) {
        //     this.tempNodeInfo.children.push(this.ruleInfo)
        //   }
        // }
        console.log(this.ruleInfo.id)
        this.$message({
          type: 'success',
          message: '操作成功!'
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    getRuleNodeLabel() {
      debugger
      let opreate = this.ruleInfo.operator1 == "" ? "" : this.ruleInfo.operator1 == ">" ? "<" : (this.ruleInfo.operator1 == ">=" ? "<=" : this.ruleInfo.operator1)
      let label = this.ruleInfo.value1 + opreate + this.ruleInfo.typeLabel + this.ruleInfo.operator2 + this.ruleInfo.value2;
      return label;
    },
    getOpreateNodeLabel() {
      return "运营决策：" + this.ruleInfo.adjustOperatorLabel;
    }
  }
}
</script>

<style lang="scss">
.opreate-strategy-detail {
  .form-line {
    .form-label {
      margin: 5px 10px 5px 0px;
      width: 120px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 800px;
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-select {
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-group {
      width: 800px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: middle;

      .el-checkbox {
        width: 70px;
      }
    }
  }
  .model-title {
    margin: 20px 10px;
    font-size: 18px;
    font-weight: bold;
  }
  .opreate-box {
    margin-top: 20px;
    margin-left: 20px;
  }
  .breadcrumb {
    margin: 20px 10px;
  }
}
</style>
